import { Component, OnInit, ViewChild } from '@angular/core';
import {
  SnomedConcept,
  SnomedConceptSearchParams,
  SnomedDescription,
  SnomedDescriptionSearchParams,
  SnomedExpressionConcept,
} from 'app/mdm/terminology/snomed/services/snomed';
import { ActivatedRoute } from '@angular/router';
import { SnomedMdmService } from 'app/mdm/terminology/snomed/services/snomed-mdm.service';
import { SnomedInputSearchComponent } from 'app/mdm/terminology-lib/components/snomed/search/snomed-input-search.component';
import { SnomedFormComponent } from 'app/mdm/terminology-lib/components/snomed/form/snomed-form.component';
import { SnomedUtil } from 'app/mdm/terminology-lib/components/snomed/snomed-util';

@Component({
  templateUrl: './snomed-view.component.html',
})
export class SnomedViewComponent implements OnInit {
  public concept: SnomedConcept;
  public conceptParams: SnomedConceptSearchParams = new SnomedConceptSearchParams();
  public descriptionParams: SnomedDescriptionSearchParams = {};
  public conceptName: string;
  public expression: string;
  public relationships: Array<any> = [];
  public refsets: Array<SnomedConcept> = [];
  public descriptions: Array<SnomedDescription> = [];
  public translations: Array<SnomedDescription> = [];

  @ViewChild('snomedSearch') public snomedSearch: SnomedInputSearchComponent;
  @ViewChild('snomedForm') public snomedForm: SnomedFormComponent;

  constructor(private snomedMdmService: SnomedMdmService, private route: ActivatedRoute) {}

  public ngOnInit(): void {
    const id = this.route.snapshot.paramMap.get('id');
    this.conceptSelected(id);
  }

  public conceptSelected(id: string): void {
    if (id) {
      this.snomedMdmService.getConcept(id).subscribe((c) => {
        this.concept = c;
        this.getRefsets(c.conceptId);
        this.getCustomDescriptions(c.conceptId);
        this.relationships = c.relationships.filter((r) => r.active === true);
        this.descriptions = c.descriptions.filter((d) => d.active === true);
      });
    }
  }

  private getRefsets(conceptId: string): void {
    this.snomedMdmService.loadRefsets(conceptId).subscribe((resp) => (this.refsets = resp));
  }

  private getCustomDescriptions(conceptId: string): void {
    this.snomedMdmService.getDescriptions(conceptId).subscribe((resp) => {
      this.translations = resp;
    });
  }

  public resetConcept(): void {
    this.concept = null;
  }

  public openSearch(): void {
    this.conceptParams.term = '';
    this.descriptionParams.term = '';
    this.snomedSearch.openDrawer();
  }

  public updateExpression(concept: SnomedExpressionConcept): void {
    this.expression = SnomedUtil.createExpression(concept);
  }
}
